<template>
    <div>
        <slot></slot>
        <div v-if="getError(name)" class="form-control-feedback">{{getError(name)}}</div>
    </div>
</template>

<script>
export default
{
    name: 'InputValidation',
    props: ['formerror', 'name'],
    methods:
    {
        getError(fieldName)
        {
            const me = this;

            if (me.formerror && me.formerror.errors)
            {
                for (const error of me.formerror.errors)
                {
                    if (error.params && error.params.field === fieldName)
                    {
                        let str = me.$t(`${error.notice}`);

                        if (error.params.value != null)
                        {
                            str += ` ${error.params.value}`;
                        }
                        return str;
                    }
                }
            }

            return false;
        },
    },
};
</script>